export default {
    // 数値3桁ごとにカンマ「,」を付与した文字列を返す
    addComma(...values) {
        const len = values.length;
        let sum = 0;
        let result = '';

        for (let i = 0; i < len; i++) {
            sum += parseInt(values[i], 10);
        }

        if (typeof sum === 'number' && isFinite(sum)) {
            result = String(sum);
            result = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        }

        return result;
    },

    // 全角文字を半角文字に変換
    convertFullWidthStringToHalfWidthString(value) {
        const valueString = String(value);
        const convertedString = valueString.replace(/[\uFF01-\uFF5E\uFFE0-\uFFE6]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xFEE0));

        return convertedString;
    },

    // カンマつき文字列をカンマなし文字列に変換
    convertStringWithoutComma(value) {
        const valueString = String(value);
        const convertedString = valueString.replace(/,/g, '');

        return convertedString;
    },

    // 文字列を数値に変換（全角数値対応）
    convertStringToNumber(value) {
        const convertedValue = this.convertFullWidthStringToHalfWidthString(value);
        const convertedValueWithoutComma = this.convertStringWithoutComma(convertedValue);
        let convertedNumber = parseInt(convertedValueWithoutComma, 10);

        if (typeof convertedNumber !== 'number' || !isFinite(convertedNumber)) {
            convertedNumber = '';
        }

        return convertedNumber;
    },

    // 有効な数値文字列か否か判定
    isNumberString(numberString) {
        const number = this.convertStringToNumber(numberString);
        let result = false;

        if (typeof number === 'number' && isFinite(number)) {
            result = true;
        }

        return result;
    },

    // 与 select 要素から、選択されている option 要素の textContent を抽出する
    //
    // CAUTION: 複数選択には未対応
    extractOptionElementTextContentBySelectElement(selectElement) {
        const optionElements = Array.from(selectElement.getElementsByTagName('option'));
        const noptionElements = optionElements.length;
        let selectedOptionElement = null;
        let textContent = '';

        for (let o = 0; o < noptionElements; o++) {
            const optionElement = optionElements[o];

            if (optionElement.selected) {
                selectedOptionElement = optionElement;
                break;
            }
        }

        if (selectedOptionElement !== null) {
            textContent = selectedOptionElement.textContent;
            textContent = textContent.trim();
        }

        return textContent;
    },

    // 与 input 要素から、関連づけられている label 要素の textContent を探索する
    //
    // CAUTION: for 属性と id 属性による関連づけには未対応
    findLabelTextByInputElement(inputElement) {
        let parentNode = null;
        let labelText = '';

        do {
            parentNode = inputElement.parentNode;

            if (parentNode && typeof parentNode === 'object' && parentNode.nodeType === 1 && parentNode.tagName.toLowerCase() === 'label') {
                break;
            }
        } while (parentNode === null);

        if (parentNode && typeof parentNode === 'object' && parentNode.nodeType === 1 && parentNode.tagName.toLowerCase() === 'label') {
            labelText = parentNode.textContent;
            labelText = labelText.trim();
        }

        return labelText;
    },

    // スマートデバイスであるか否か判定する
    checkSmartDevice() {
        const userAgent = window.navigator.userAgent || '';
        let smartDevice = false;

        if (0 <= userAgent.indexOf('Mobile') && (0 <= userAgent.indexOf('iPhone') || 0 <= userAgent.indexOf('Android'))) {
            smartDevice = true;
        }

        return smartDevice;
    },

    // 新規ウインドウを開く
    openWindow(event) {
        const element = event.currentTarget;
        const url = element.href || 'about:blank';
        const name = element.getAttribute('data-window-name') || '_blank';
        const widthString = element.getAttribute('data-window-width') || '';
        const width = parseInt(widthString, 10) || 0;
        const heightString = element.getAttribute('data-window-height') || '';
        const height = parseInt(heightString, 10) || 0;
        const configs = new Map([
            ['menubar', 'no'],
            ['toolbar', 'no'],
            ['location', 'yes'],
            ['status', 'yes'],
            ['resizable', 'yes'],
            ['scrollbars', 'yes']
        ]);
        let configString = '';
        let windowObject = null;

        event.preventDefault();

        if (0 < width) {
            configs.set('width', width);
        }

        if (0 < height) {
            configs.set('height', height);
        }

        for (let [key, value] of configs) {
            configString += key + '=' + value + ',';
        }

        configString = configString.replace(/,$/, '');

        windowObject = window.open(url, name, configString);

        if (windowObject && typeof windowObject === 'object' && windowObject.focus) {
            windowObject.focus();
        }

        return windowObject;
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/Utils.js